import script from "./TextPreviewer.vue?vue&type=script&setup=true&lang=js"
export * from "./TextPreviewer.vue?vue&type=script&setup=true&lang=js"

import "./TextPreviewer.vue?vue&type=style&index=0&id=44ecda42&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44ecda42"]])

export default __exports__